<ng-container [formGroup]="formGroupCampaignTypeData">
    <mdb-form-control class="form-fill" data-panel="settings" >
        <app-mdbp-input mdbInput formControlName="goal" data-panel="settings" [isCurrencyMask]="true" label='Optional Campaign Goal'>
            <input  #inputNameC currencyMask formControlName="goal" class="form-control form-control--paybee"/>
        </app-mdbp-input>
    </mdb-form-control>

    <app-mdb-switch label="Hide custom amount" formControlName="hideCustom"></app-mdb-switch>
    <div class="divider"></div>

    <div class="d-flex align-items-center">
        <app-mdb-switch label="Hide contribution amount" formControlName="hideSelfContribution"></app-mdb-switch>
    </div>
    <div class="divider"></div>

    <div class="d-flex align-items-center">
        <app-mdb-switch label="Include different amounts to donate to a fundraiser" formControlName="useAmounts"></app-mdb-switch>
        <div class="d-flex align-items-center ml-2 h-100">
            <app-text-popover
                placement="right"
                type="content"
                text="Donors will see different amounts when donating to an existing champion's fundraiser."
                title=""
            >
            </app-text-popover>
        </div>
    </div>
    <div class="divider"></div>

    <div class="d-flex align-items-center">
        <app-mdb-switch label="Include different percentages to donate to a fundraiser" formControlName="usePercentage"></app-mdb-switch>
        <div class="d-flex align-items-center ml-2 h-100">
            <app-text-popover
                placement="right"
                type="content"
                text="Donors will see different percentages of the goal amount when donating to an existing champion's fundraiser."
                title=""
            >
            </app-text-popover>
        </div>
    </div>
    <div class="divider"></div>

    <div class="d-flex align-items-center">
        <app-mdb-switch label="Enable teams" formControlName="teamEnabled"></app-mdb-switch>
        <div class="d-flex align-items-center ml-2 h-100">
            <app-text-popover
                placement="right"
                type="content"
                text="Enabling teams will enforce champions to select a team when creating a fundraiser."
                title=""
            >
            </app-text-popover>
        </div>
    </div>
    <div style="padding-left: 44px;" *ngIf="formGroupCampaignTypeData.value.teamEnabled">
        <app-mdb-switch label="Set &quot;Team&quot; as the default tab in the leaderboard" formControlName="leaderboardTeamDefaultTab"></app-mdb-switch>
    </div>
    <div class="divider"></div>

    <ng-container *ngIf="campaign.controls.streetAddressRequired.value">
        <div class="d-flex align-items-center">
            <app-mdb-switch label="Ask fundraiser donors for street address" formControlName="streetAddressRequired"></app-mdb-switch>
            <div class="d-flex align-items-center ml-2 h-100">
                <app-text-popover
                    placement="right"
                    type="content"
                    text="Enabling this will ask both fundraiser champions and donors for their street address."
                    title=""
                >
                </app-text-popover>
            </div>
        </div>
        <div class="divider"></div>
    </ng-container>

    <ng-container *ngIf="campaign.controls.phoneNumRequired.value">
        <div class="d-flex align-items-center">
            <app-mdb-switch label="Ask fundraiser donors for phone number" formControlName="phoneNumRequired"></app-mdb-switch>
            <div class="d-flex align-items-center ml-2 h-100">
                <app-text-popover
                    placement="right"
                    type="content"
                    text="Enabling this will ask both fundraiser champions and donors for their phone number."
                    title=""
                >
                </app-text-popover>
            </div>
        </div>
        <div class="divider"></div>
    </ng-container>

    <ng-container *ngIf="campaign.controls.additionalInfoRequired.value">
        <div class="d-flex align-items-center">
            <app-mdb-switch label="Ask fundraiser donors for the same additional information" formControlName="additionalInfoRequired"></app-mdb-switch>
            <div class="d-flex align-items-center ml-2 h-100">
                <app-text-popover
                    placement="right"
                    type="content"
                    text="Enabling this will ask both fundraiser champions and donors for same additional information."
                    title=""
                >
                </app-text-popover>
            </div>
        </div>
        <div class="divider"></div>
    </ng-container>

    <ng-container *ngIf="campaign.controls.additionalInfoSelectRequired.value">
        <div class="d-flex align-items-center">
            <app-mdb-switch label="Ask fundraiser donors for the same additional information with selection options" formControlName="additionalInfoSelectRequired"></app-mdb-switch>
            <div class="d-flex align-items-center ml-2 h-100">
                <app-text-popover
                    placement="right"
                    type="content"
                    text="Enabling this will ask both fundraiser champions and donors for same additional information with selection options."
                    title=""
                >
                </app-text-popover>
            </div>
        </div>
        <div class="divider"></div>
    </ng-container>

    <ng-container *ngIf="campaign.controls.dedicationEnabled.value">
        <div class="d-flex align-items-center">
            <app-mdb-switch label="Ask fundraiser donors for their dedication" formControlName="dedicationEnabled"></app-mdb-switch>
            <div class="d-flex align-items-center ml-2 h-100">
                <app-text-popover
                    placement="right"
                    type="content"
                    text="Enabling this will ask both fundraiser champions and donors for their dedication."
                    title=""
                >
                </app-text-popover>
            </div>
        </div>
        <div class="divider"></div>
    </ng-container>

    <div class="d-flex align-items-center">
        <app-mdb-switch label="Enable donor pledges per milestone" formControlName="pledgePerEvent"></app-mdb-switch>
        <div class="d-flex align-items-center ml-2 h-100">
            <app-text-popover
                size="md"
                placement="right"
                type="content"
                text="Switching this ON will replace donor donation options with donor pledge options per milestone achieved. After the donor selects a pledge option, they must save their payment information. After the event ends and total milestones have been calculated, all donors are charged as per their pledge. For example, if you are hosting a Read-A-Thon and the milestone is books read, all donors are charged on their pledges per book read at the time of the event ending."
                title=""
            >
            </app-text-popover>
        </div>
    </div>

    <div *ngIf="formGroupCampaignTypeData.controls.pledgePerEvent.value" style="padding-left: 44px;">
        <mdb-form-control class="form-fill">
            <div class="d-flex">
                <app-mdbp-input mdbInput formControlName="maxEventCount" class="w-100" [isCurrencyMask]="true" label='Max milestones possible'>
                    <input #inputNameC currencyMask formControlName="maxEventCount" [options]="{ allowNegative: false, prefix: '', inputMode: 1 }"   class="form-control form-control--paybee"/>
                </app-mdbp-input>
                <app-text-popover
                    size="md"
                    placement="right"
                    type="content"
                    text="Indicate the maximum milestones a donor may be charged for. For example, let's say you are hosting a Read-A-Thon, the milestone is books read and the maximum books read is 50. Even if the event ends with 60 books read, the maximum donors will be charged for is 50 books."
                    title=""
                    class="d-flex align-items-center"
                >
                </app-text-popover>
            </div>
            <mdb-error class="form-fill-error"  *ngIf="formGroupCampaignTypeData.controls.maxEventCount.invalid && formGroupCampaignTypeData.controls.maxEventCount.touched ">Please provide Max milestones possible more than 0</mdb-error>
        </mdb-form-control>

        <app-datetime
            data-panel="settings"
            dateLabel="Event End Date"
            timeLabel="Event End Time"
            formControlName="closingDateTimeUnix"
            [myDatePickerOptions]="closingDateTimeUnixOptions"
            [required]="closingDateTimeUnixRequired"
            [submitted]="submitted"
        ></app-datetime>

        <mdb-form-control class="form-fill">
            <div class="d-flex w-100">
                <app-mdbp-input mdbInput formControlName="eventName" class="w-100" label='Milestone Name'></app-mdbp-input>
                <app-text-popover
                    size="md"
                    placement="right"
                    type="content"
                    text='On the donor side, this will be displayed as "Select a pledge amount per <milestone name>". For example, let&quot;s say you are hosting a Read-A-Thon, the milestone is books read, you would enter the milestone name as "book read".'
                    title=""
                    class="d-flex align-items-center"
                >
                </app-text-popover>
            </div>
            <mdb-error class="form-fill-error"  *ngIf="formGroupCampaignTypeData.controls.eventName.hasError('required') && formGroupCampaignTypeData.controls.eventName.touched ">Please provide Milestone Name</mdb-error>
        </mdb-form-control>
    </div>
</ng-container>